var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 3.30469L9.94531 1.03516C9.69922 0.789062 9.37109 0.625 9.01562 0.625H1.6875C0.949219 0.625 0.375 1.22656 0.375 1.9375V11.5625C0.375 12.3008 0.949219 12.875 1.6875 12.875H11.3125C12.0234 12.875 12.625 12.3008 12.625 11.5625V4.23438C12.625 3.87891 12.4609 3.55078 12.2148 3.30469ZM6.5 11.125C5.51562 11.125 4.75 10.3594 4.75 9.375C4.75 8.41797 5.51562 7.625 6.5 7.625C7.45703 7.625 8.25 8.41797 8.25 9.375C8.25 10.3594 7.45703 11.125 6.5 11.125ZM9.125 2.8125V5.54688C9.125 5.73828 8.96094 5.875 8.79688 5.875H2.45312C2.26172 5.875 2.125 5.73828 2.125 5.54688V2.70312C2.125 2.53906 2.26172 2.375 2.45312 2.375H8.6875C8.76953 2.375 8.85156 2.42969 8.93359 2.48438L9.01562 2.56641C9.07031 2.64844 9.125 2.73047 9.125 2.8125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.44a35c704b5a9cda1399efdc9bedeac1.svg";
export { ForwardRef as ReactComponent };